/** Mirrors SuprBackend `src/constants/promoCoupons.ts` — customer-app promo coupon rules. */
export const PROMO_COUPON_TYPE = 'app_promo_coupons';

export const PROMO_COUPON_MODULES = [
  { value: 'food', label: 'Food' },
  { value: 'grocery', label: 'Grocery' },
  { value: 'transport', label: 'Transport / Taxi' },
  { value: 'on_demand', label: 'Home Services' },
  { value: 'porter', label: 'Porter' },
] as const;

export const PROMO_COUPON_AUDIENCES = [
  { value: 'all', label: 'All customers' },
  { value: 'new_users', label: 'New customers only' },
] as const;

export const PROMO_COUPON_LIMITS = {
  name: 60,
  description: 200,
  codeMin: 3,
  codeMax: 20,
  maxPercent: 100,
  maxAmount: 100000,
  maxUsage: 1000000,
  maxNewUserDays: 365,
} as const;

export const PROMO_COUPON_CODE_PATTERN = /^[A-Z0-9]+$/;
export const DEFAULT_NEW_USER_DAYS = 30;

const CODE_PREFIX: Record<string, string> = {
  food: 'FOOD',
  grocery: 'GROC',
  transport: 'RIDE',
  on_demand: 'HOME',
  porter: 'PORT',
};

export function couponModuleLabel(value?: string) {
  return PROMO_COUPON_MODULES.find((m) => m.value === value)?.label || value || '—';
}

export function audienceLabel(value?: string, days?: unknown) {
  if (value === 'new_users') return `New customers (joined ≤ ${Number(days) || DEFAULT_NEW_USER_DAYS} days)`;
  return 'All customers';
}

/** Same scheme as the server: FOOD20P / RIDE100, with a number appended when taken. */
export function suggestCouponCode(moduleKey: string, discountType: string, discountValue: string, takenCodes: Set<string>) {
  const value = Math.round(Number(discountValue) || 0);
  const base = `${CODE_PREFIX[moduleKey] || 'PROMO'}${value > 0 ? value : ''}${discountType === 'percentage' ? 'P' : ''}`.slice(0, 16);
  if (!takenCodes.has(base)) return base;
  for (let i = 2; i < 1000; i += 1) {
    if (!takenCodes.has(`${base}${i}`)) return `${base}${i}`;
  }
  return `${base}${Date.now() % 100000}`;
}
